var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M1.33301 4L5.94169 6.61131C7.64074 7.574 8.35861 7.574 10.0577 6.61131L14.6663 4",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M1.34352 8.9839C1.3871 11.0276 1.40889 12.0494 2.16298 12.8064C2.91706 13.5634 3.96656 13.5897 6.06556 13.6424C7.35921 13.675 8.64014 13.675 9.93381 13.6424C12.0328 13.5897 13.0823 13.5634 13.8364 12.8064C14.5905 12.0494 14.6123 11.0276 14.6558 8.9839C14.6699 8.32676 14.6699 7.67356 14.6558 7.01643C14.6123 4.97274 14.5905 3.95089 13.8364 3.19394C13.0823 2.43698 12.0328 2.41062 9.93381 2.35788C8.64014 2.32537 7.35921 2.32537 6.06555 2.35787C3.96656 2.4106 2.91706 2.43697 2.16297 3.19393C1.40889 3.95088 1.3871 4.97273 1.34351 7.01643C1.3295 7.67356 1.32951 8.32676 1.34352 8.9839Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b5e0f3497f55f47143a20301de08871d.svg";
export { ForwardRef as ReactComponent };